import SearchInput from 'components/SearchInput'
import {
  FilterFlex,
  FilterFlexButton,
  FilterOpenClose,
  FilterText,
  FilterTextLabel,
  InputDivider,
  TableTop,
} from 'components/UIComponents/ReportSearchFilter/Style/style.js'
import BlackFilter from 'components/icons/BlackFilter'
import OpenFilter from 'components/icons/OpenFilter.js'
import React from 'react'

const ReportSearchFilter = ({
  totalCount = 0,
  currentCount = 0,
  searchValue,
  setSearchValue,
  open,
  setOpen,
  placeholder = 'Search by keyword',
}) => {
  return (
    <TableTop centerVertically>
      <FilterFlex centerVertically>
        <FilterOpenClose
          onClick={() => {
            setOpen(!open)
          }}
        >
          <BlackFilter />
          <FilterText>{'Filters'}</FilterText>
        </FilterOpenClose>
      </FilterFlex>
      <FilterFlexButton centerVertically onClick={() => setOpen(true)}>
        {open ? '' : <OpenFilter />}
      </FilterFlexButton>

      <SearchInput
        background="#F8F8F8"
        width={'20%'}
        placeholder={placeholder}
        bordered={false}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      <InputDivider type="vertical" />
      <FilterTextLabel>
        Showing {}
        {isNaN(currentCount) ? 0 : currentCount} of {totalCount}
      </FilterTextLabel>
    </TableTop>
  )
}

export default ReportSearchFilter
